import { Center } from '@zorro/web/design-system';
import React from 'react';

import { SVGIconProps } from '../types';

type Props = {
  style?: SVGIconProps;
  className?: string;
};
export const EmptyResultIcon = ({ style, className }: Props) => {
  return (
    <Center style={style} className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="87"
        height="74"
        viewBox="0 0 87 74"
        fill="none"
      >
        <rect x="1" y="0.5" width="85" height="21" rx="3.5" stroke="#EDEFF6" />
        <rect x="6.5" y="6" width="18" height="10" rx="2" fill="#EDEFF6" />
        <rect x="32.5" y="9" width="46" height="4" rx="2" fill="#EDEFF6" />
        <rect x="1" y="26.5" width="85" height="21" rx="3.5" stroke="#EDEFF6" />
        <rect x="6.5" y="32" width="18" height="10" rx="2" fill="#EDEFF6" />
        <rect x="32.5" y="35" width="46" height="4" rx="2" fill="#EDEFF6" />
        <rect x="1" y="52.5" width="85" height="21" rx="3.5" stroke="#EDEFF6" />
        <rect x="6.5" y="58" width="18" height="10" rx="2" fill="#EDEFF6" />
        <rect x="32.5" y="61" width="46" height="4" rx="2" fill="#EDEFF6" />
      </svg>
    </Center>
  );
};
